function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaperclip = function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 2C7.2 2 5 4.2 5 7v8c0 .6-.4 1-1 1s-1-.4-1-1V7c0-3.9 3.1-7 7-7s7 3.1 7 7v8c0 2.8-2.2 5-5 5s-5-2.2-5-5V7c0-1.7 1.3-3 3-3s3 1.3 3 3v8c0 .6-.4 1-1 1s-1-.4-1-1V7c0-.6-.5-1-1-1-.6 0-1 .5-1 1v8c0 1.7 1.3 3 3 3s3-1.3 3-3V7c0-2.8-2.2-5-5-5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgPaperclip;